import { PersonTypeDTO } from "../dto/PersonTypeDTO";
import { PersonType } from "../models/Person/PersonType";

export const personTypeMapper = (dto: PersonTypeDTO): PersonType => {
  return new PersonType({
    id: dto.typeId,
    name: dto.typeName,
    active: dto.active === "Y",
    displayOrder: dto.displayOrder,
  });
};
